import React from 'react';

const BuildSelectOptions = options => {
  return options.map(({key, value}) => {
    return <option key={key} value={key}>{value}</option>;
  });
};

const BuildRadioOptions = (options, rowKey='', questionKey='', valueChanged, answer = "") => {
  return options.map(({key, value}) => {
    return <label htmlFor={`${rowKey}.${questionKey}.${key}`} className="custom-control" key={`${rowKey}.${questionKey}.${key}`}>
      <input className="answer custom-control-input radio" name={`${rowKey}.${questionKey}`} id={`${rowKey}.${questionKey}.${key}`} type="radio" onChange={valueChanged} value={key} checked={key === answer} />
      <span className="indicator"><span className="fa"></span></span>
      <span className="answerLabel custom-control-description">{value}</span>
    </label>;
  });
};

const BuildCheckboxOptions = (options, rowKey='', questionKey='', valueChanged, answers = []) => {
  const answerSet = answers ? answers : [];
  return options.map(({key, value}) => {
    return <label htmlFor={`${rowKey}.${questionKey}.${key}`} className="custom-control" key={`${rowKey}.${questionKey}.${key}`}>
      <input className="answer custom-control-input checkbox" name={`${rowKey}.${questionKey}`} id={`${rowKey}.${questionKey}.${key}`} type="checkbox" onChange={valueChanged} value={key} checked={answerSet.includes(key)} />
      <span className="indicator"><span className="fa"></span></span>
      <span className="answerLabel custom-control-description">{value}</span>
    </label>;
  });
};

export {
  BuildSelectOptions,
  BuildRadioOptions,
  BuildCheckboxOptions
};



/** WEBPACK FOOTER **
 ** ./src/main/js/questionGroupBuilder/util/BuildOptions.js
 **/